export const getUserInfo = state => state.userInfo.data ? state.userInfo.data : {id: null};
export const getUserWinningInfo = state => state.userWinningInfo.data;
export const getNicknameError = state => state.nicknameError;
